import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import Vue from 'vue';
Vue.filter('documentoCliente', function (documento) {
  if (!documento) {
    return '';
  }
  var mascara = documento.length > 10 ? '###.###.###-##' : 'XX.XXX.XXX/XXXX-XX';
  return Vue.filter('VMask')(documento, mascara);
});
Vue.filter('statusContrato', function (status) {
  return {
    ATIVO: 'Ativo',
    ATRASADO: 'Atrasado',
    CANCELADO: 'Cancelado',
    EM_ATRASO: 'Em atraso',
    EM_DIA: 'Em dia',
    FINALIZADO: 'Quitado',
    PENDENTE: 'Pendente',
    VENCE_HOJE: 'Vence hoje'
  }[status] || status;
});
Vue.filter('telefone', function (telefone) {
  if (!telefone) {
    return '';
  }
  return Vue.filter('VMask')(telefone, '(##) #####-####');
});
Vue.filter('linhaDigitavel', function (linhaDigitavel) {
  if (!linhaDigitavel) {
    return '';
  }
  return Vue.filter('VMask')(linhaDigitavel, "#####.##### #####.###### ######.#### ## # ##############");
});
Vue.filter("fomatadorReal", function (value) {
  if (typeof value !== "number" && typeof value !== "string" || isNaN(value)) return value;
  var valorInteiro = parseFloat(value);
  return valorInteiro.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL'
  });
});
Vue.filter('data', function (data) {
  if (!data) return '';
  var _data$split$0$split = data.split('T')[0].split('-'),
    _data$split$0$split2 = _slicedToArray(_data$split$0$split, 3),
    ano = _data$split$0$split2[0],
    mes = _data$split$0$split2[1],
    dia = _data$split$0$split2[2];
  if (!ano || !mes || !dia) {
    return data;
  }
  return "".concat(dia, "/").concat(mes, "/").concat(ano);
});